import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { GeneralService } from './general.service';
import { environment } from 'src/environments/environment';
import { MsgService } from '../local/msg.service';
import { ResponseModel } from '../../models/entity/response.model';
import { FilterBaseModel } from '../../models/viewModel/filterBase.model';

@Injectable({
  providedIn: 'root'
})
export class ServicesService extends GeneralService {

  constructor(
    protected messageService: MsgService,
    protected httpClient: HttpClient,
  ) {
    super(messageService, httpClient, environment.apiUrl, 'Service');
  }

  async getListService(viewModel: FilterBaseModel): Promise<ResponseModel> {
    const res = await this.postCustomApi('GetService', viewModel);
    return res;
  }
}
